<template>
<div>

<!--  {{sessionKeyObj}} {{localKeysObjs}} {{oldestKeyObj}}-->
  <div v-if="duplicateTabCheck">
    <RetouchersOrderFuncBasedNewProstoy></RetouchersOrderFuncBasedNewProstoy>
  </div>
  <div v-else>
    <div class="uk-card uk-box-shadow-medium uk-margin uk-padding uk-text-center uk-width-xlarge uk-margin-auto">
      <div class="uk-margin">
        <md-icon class="uk-text-warning md-size-2x">warning</md-icon>
      </div>
      <div class="uk-margin uk-text-bold uk-text-uppercase">{{ local_page_keys.error_attention }}</div>
      <div class="uk-margin">{{ local_page_keys.error_attention_duplicate_text }}</div>
      <div class="uk-margin-medium-top uk-grid uk-flex-middle uk-flex-center" data-uk-grid>
        <div>
          <button class="uk-button tm-button-blue" type="button" @click="reload" style="min-width: 160px; text-transform: inherit; font-weight: normal">
            {{ local_page_keys.error_attention_duplicate_reload_page }}
          </button>
        </div>
        <div>
          <button class="uk-button tm-button-success" type="button" @click="closeTab" style="min-width: 160px; text-transform: inherit; font-weight: normal">
            {{ local_page_keys.error_attention_duplicate_close_tab }}
          </button>
        </div>
      </div>
    </div>
  </div>

</div>

</template>

<script>

import RetouchersOrderFuncBasedNewProstoy from "@/pages/Dashboard/Pages/RetouchersOrderFuncBasedNewProstoy";

export default {
  name: 'RetouchersOrderFuncBasedNewProstoyWrapper',
  data: () => ({
    channel: null,
    keyObjs:[],
    local_page_keys: {},
  }),
  components: {
    RetouchersOrderFuncBasedNewProstoy
  },
  methods: {
    closeTab() {
      // Attempt to close the current tab
      window.close();
      // Optionally, display a message if the tab cannot be closed
      alert(this.local_page_keys.error_alert_attention_duplicate_text);
    },
    setupBroadcastChannel() {
      if ('BroadcastChannel' in window) {
        this.channel = new BroadcastChannel('tab_channel');
        this.channel.onmessage = this.handleMessage;

        // When the tab is loaded, it sends a message to see if there are other tabs open
        this.channel.postMessage({ type: 'tab-check', timestamp: Date.now() });
      }
    },

    handleMessage(event) {
      if (event.data.type === 'tab-check') {
        // Respond to the new tab that this tab is already open
        this.channel.postMessage({ type: 'tab-response', timestamp: Date.now() });
      } else if (event.data.type === 'tab-response') {

        // Received a response from an existing tab, you can alert the user or take other actions here
        try{
          //alert('This application is already open in another tab. Please use that one.');
          // Optionally, close the current tab if it's not the first one
          window.close();
        } catch (e) {
          window.close();
        }
      }
    },
    reload(){
      location.reload(true);
    },

    generateKeyObject() {
      return {
        key: Math.random().toString(36).substring(2, 15),
        createdAt: new Date().toISOString() // Store the creation time
      };
    },
    storeKeyObject(keyObj) {
      // Retrieve the existing array of key objects from LocalStorage, or initialize a new array if none exists
      const keyObjs = JSON.parse(localStorage.getItem('keyObjs') || '[]');
      keyObjs.push(keyObj);
      localStorage.setItem('keyObjs', JSON.stringify(keyObjs));
      this.keyObjs = keyObjs;
      // For SessionStorage, store the current tab's key object
      sessionStorage.setItem('sessionKeyObj', JSON.stringify(keyObj));
    },
    handleStorageChange(event) {
      // Check if the change is for the 'keyObjs' key
      if (event.key === 'keyObjs') {
        this.keyObjs = event.newValue;
      }
    },
  },
  async created() {
    ////-------- this code must be on the top
    const keyObj = this.generateKeyObject();
    this.storeKeyObject(keyObj);
    window.addEventListener('storage', this.handleStorageChange);
    // Ensure to remove the event listener when the component is destroyed
    // this.$once('hook:beforeDestroy', () => {
    //   window.removeEventListener('storage', this.handleStorageChange);
    // });
    window.addEventListener('beforeunload', function () {
      const sessionKeyObj = JSON.parse(sessionStorage.getItem('sessionKeyObj'));
      const keyObjs = JSON.parse(localStorage.getItem('keyObjs') || '[]');
      const filteredKeyObjs = keyObjs.filter(keyObj => keyObj.key !== sessionKeyObj.key);
      localStorage.setItem('keyObjs', JSON.stringify(filteredKeyObjs));

      // SessionStorage is automatically cleared on tab close, but explicitly removing the item can ensure cleanliness
      sessionStorage.removeItem('sessionKeyObj');
    });
    ////-------- this code must be on the top



    this.local_page_keys = await this.$filtergetLocalisationPages(['order-downtime']);

  },
  mounted() {
    this.setupBroadcastChannel();

  },

  computed: {
    duplicateTabCheck(){
      const check = this.sessionKeyObj && this.mostRecentKeyObj && 'key' in this.mostRecentKeyObj && 'key' in this.sessionKeyObj && this.sessionKeyObj.key === this.mostRecentKeyObj.key;
      //this.$emit('duplicateTabCheck', check);
      sessionStorage.setItem('notDuplicateTabCheck', check);
      return check;
    },
    sessionKeyObj(){
      return JSON.parse(sessionStorage.getItem('sessionKeyObj') || null);
    },
    localKeysObjs(){
      return this.keyObjs;
    },
    oldestKeyObj(){
      const keyObjs = this.keyObjs;
      if(keyObjs.length > 0){
        return keyObjs.reduce((oldest, keyObj) => {
          return new Date(oldest.createdAt) < new Date(keyObj.createdAt) ? oldest : keyObj;
        }, keyObjs[0]);
      }
      return null;
    },
    mostRecentKeyObj(){
      const keyObjs = this.keyObjs;
      if(keyObjs.length > 0) {
        return keyObjs.reduce((mostRecent, keyObj) => {
          return new Date(mostRecent.createdAt) > new Date(keyObj.createdAt) ? mostRecent : keyObj;
        }, keyObjs[0]);
      }
      return null;
    }

  },
  beforeDestroy() {
    if (this.channel) {
      this.channel.close();
    }
  },
  watch: {
    keyObjs(newVal, oldVal) {
      const newValString = JSON.stringify(newVal);
      const oldValString = JSON.stringify(oldVal);

      // Check if the serialized strings are the same
      if (newValString !== oldValString) {
        // Perform actions based on the change
        if(typeof newVal == 'string') newVal = JSON.parse(newVal || '[]');
        this.keyObjs = newVal;
      } else {
      }
    }
  }
}
</script>

<style>
.alert-box {
  /* Style your alert box */
  padding: 20px;
  background-color: #f44336; /* Red */
  color: white;
  margin-bottom: 15px;
}
</style>